export const KB_B_SIZE = 1024; // 1KB in bytes
export const MB_B_SIZE = KB_B_SIZE * 1024; // 1MB in bytes

export const NAVBAR_HEIGHT_DESKTOP = 52;
export const NAVBAR_HEIGHT_MOBILE = 60;
export const LOCATION_SEARCH_HEIGHT_MOBILE = 60;
export const WORKBENCH_HEIGHT_MOBILE = 60; // %
export const WORKBENCH_WIDTH_DESKTOP = 500;
export const EXPLORER_WIDTH_DESKTOP = 428;

export const COMPARABLES_LIMIT = 2000;
export const COMPARABLES_ZOOPLA_LIMIT = 200;

export enum DocumentType {
  PURCHASED_TITLE_PLAN = "TitlePlanDocument",
  PURCHASED_TITLE_REGISTER = "TitleRegisterDocument",
  PURCHASED_OS_MAP_PRINT = "OSMapPrint",
  UPLOADED = "UploadedFile",
  THIRD_PARTY_ON_DEMAND_DELIVERABLE = "ThirdPartyOnDemandDeliverable",
  ATKINS = "AtkinsDeliverable",
}

export const TransactionTypes = {
  Other: "Top-up",
  TitleRegisterDocument: "Title Registration",
  TitlePlanDocument: "Title Plan",
  OSMapPrint: "OS Map Print",
  LetterSending: "Letter Sending",
  Atkins: "Atkins",
} as const;

export const DEMOGRAPHICS_SECTION_IDS = [
  "age",
  "populationDensity",
  "populationGrowth",
  "income",
  "affordability",
  "deprivation",
  "employment",
  "occupancy",
  "dwellings",
  "propertyTenure",
];

export const US_DEMOGRAPHICS_SECTION_IDS = ["unemployment", "income", "population", "age", "housing", "households"];

export enum CopyStates {
  DEFAULT = "DEFAULT",
  COPIED = "COPIED",
}

export enum ShareSiteAccessType {
  REQUEST_ACCESS = "request_access",
  ACCESS_REQUESTED = "access_requested",
}
